export const ROUTE_PATHS = {
  HOME: '/',
} as const;
